export const getDefault = () => {
  const schema = {
    name: 'Facts',
    backgroundColor: '#e6e7e8',
    title: 'Escreva uma frase ou citação que deseja destacar',
    /* resource: 'app.organism.facts.university.title', */
    source: '',
    text: '',
    titleStyles: {
      fontSize: '70px',
      color: '#000',
      mobileSmFontSize: '42px'
    }
  }
  return schema
}
